import type { MouseEvent, PointerEvent } from 'react';

export function stopMenuEvent(event: MouseEvent<HTMLElement>) {
  event.preventDefault();
  event.stopPropagation();
}

export function stopPointerEvent(event: PointerEvent<HTMLElement>) {
  event.stopPropagation();
}
